import React, { useEffect, useState,useImperativeHandle,forwardRef } from "react";
import { useSelector} from "react-redux";
import VIcon from "components/custom/Icon";
import { themeIcons } from "config/theme";
import { stringIsNullOrEmpty } from '../../util/Util'
import "../../assets/css/floatingchat.css"
import { useLocation,useHistory } from 'react-router-dom';
import {
  WebUrl,
} from "../../util/Constant";


const FloatingChat = forwardRef((props, ref) => {
  var { heartBeat } = useSelector((state) => state.authState);
  
  const [shouldShowFloatChannel, setShouldShowFloatChannel] = useState(false);
  const [clickCloseFloatChannel, setClickCloseFloatChannel] = useState(false);
  const [FloatChannelImg,setFloatChannelImg]=useState("");

  const [iconColor, setIconColor] = useState('#FFF');
  const floatingChat=useSelector((state)=>state.appState.floatingChat);
  const location = useLocation();
  const[channelList,setChannelList]=useState();
  const[displayChannelList,setDisplayChannelList]=useState();


  const [isChannelListOpen, setIsChannelListOpen] = useState(false);
  var _history = useHistory();
  const [spinnerWheelExist,setSpinnerWheelExist]=useState(true);

  useImperativeHandle(ref, () => ({
    changeBtmPos: () => {
      setSpinnerWheelExist(false);
    },
    changeTopPos: () => {
      setSpinnerWheelExist(true);
    },
}));

	useEffect(() => {
    
		init();

    const parentElement = document.querySelector('.page-container');
    
    if(parentElement){
    const backgroundColor = window.getComputedStyle(parentElement).backgroundColor; 
    const isDarkTheme = isDarkBackground(backgroundColor);
    setIconColor(isDarkTheme ? '#FFF' : '#383838');
    }

	}, []);


  async function init() {

    let floatingChannel=floatingChat;
    
    if(floatingChannel){
    if(!stringIsNullOrEmpty(floatingChannel?.imageUrl)){

      setFloatChannelImg(floatingChannel.imageUrl);
      setChannelList(floatingChannel.channelList);
      //setDisplayChannelList(floatingChannel.channelList);
      
      if(!clickCloseFloatChannel){
        setShouldShowFloatChannel(true);
      }

    }else{
      setShouldShowFloatChannel(false);
    } 
    }else{
      setShouldShowFloatChannel(false);
    }
  }


  const isDarkBackground = (bgColor) => {
    const rgb = bgColor.match(/\d+/g);
    if (rgb) {
      const r = parseInt(rgb[0], 10);
      const g = parseInt(rgb[1], 10);
      const b = parseInt(rgb[2], 10);
      return (r * 0.299 + g * 0.587 + b * 0.114) < 128;
    }
    return false;
  };



  const CloseBtn = (props)=> (
    <div
          className="float-channel-close-button" style={{ color: iconColor }}
          onClick={(e) => {
              e.stopPropagation();
              setShouldShowFloatChannel(false);
              setClickCloseFloatChannel(true);
          }}
    >
      <VIcon icon={themeIcons.close} className="vicon" />
    </div>
  );

  const [imgLoad, setImgLoad] = useState(false);
	
  return (
    <>
    {shouldShowFloatChannel && location.pathname !== "/"+ WebUrl.getCurrentLocale() +"/livechat" && (
    <div className={`chat-floating-container ${spinnerWheelExist ? "" : "btm"}`}>
       <div className={`float-channel-icon-group ${isChannelListOpen ? "open" : ""}`}>
       {channelList && channelList.map((icon, index) => (
        <a
            key={index}
            href={icon.cta}
            target="_blank"
            rel="noopener noreferrer"
            className="float-channel-circle-icon"
            style={{ animationDelay: `${index * 0.3}s` }}
            onClick={()=>{
              setIsChannelListOpen(false);
            }}
          >
            <img src={icon.channelImage} alt="Icon" />
          </a>
      ))}
        </div>
      <button className="float-channel-gif-button" onClick={() => {
        setIsChannelListOpen(!isChannelListOpen);
        // if (isChannelListOpen) {
        //   setTimeout(() => setDisplayChannelList(), 300);
        // } else {
        //   setTimeout(() => setDisplayChannelList(channelList), 300);
        // }
        }}>
        <img src={FloatChannelImg} alt="GIF" className="float-channel-gif-image" onLoad={() => setImgLoad(true)}/>
        {imgLoad && <CloseBtn />}
      </button>
    </div>
    )}
    </>
  );
 

});

export default FloatingChat;
